<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap black" @click="$emit('close')" @touchend="$emit('close')">
      <div
        class="modal-chat-img force-extend"
        ref="img"
        style="background-size: contain"
        @click.stop
        @touchend.stop
      >
        <!--        <vue-easy-lightbox :visible="visible" :imgs="[{ src: data.src, title: 'detail' }]" @hide="visible = false" />-->
        <!--        <zoomable-image :src="data.src" />-->
        <img ref="imageRef" :src="data.src" alt="" class="modal-img" />
        <i class="i-delete-30" @click="$emit('close')"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, toRefs } from 'vue';
import Panzoom from '@panzoom/panzoom';

const define = defineProps({
  data: {
    type: Object,
    default: {}
  }
});
const { data } = toRefs(define);
const imageRef = ref(null);
let panzoom;

onMounted(() => {
  panzoom = Panzoom(imageRef.value, {
    maxScale: 5,
    minScale: 1,
    step: 0.5,
    contain: 'outside' // (timmywil panzoom 옵션)
  });
  imageRef.value.parentElement.addEventListener('wheel', panzoom.zoomWithWheel, { passive: false });
});

onBeforeUnmount(() => {
  imageRef.value?.parentElement?.removeEventListener('wheel', panzoom.zoomWithWheel);
});
</script>

<style lang="scss" scoped>
.modal-wrap {
  &.black {
    //background-color: black;
  }
  & .force-extend {
    width: 100% !important;
    height: auto !important;
    max-height: 80%;

    & .modal-img {
      margin: 0 auto;
      width: 95% !important;
      max-height: 80vh !important;
      object-fit: contain;
    }
  }
}
</style>
/* *Created on 2023-10-04 *ProjectName user */
